export const GET_TYPE_LABEL_START = 'GET_TYPE_LABEL_START';
export const GET_TYPE_LABEL_SUCCESS = 'GET_TYPE_LABEL_SUCCESS';
export const GET_TYPE_LABEL_FAIL = 'GET_TYPE_LABEL_FAIL';

export const GET_TOPIC_TYPE_LABEL_START = 'GET_TOPIC_TYPE_LABEL_START';
export const GET_TOPIC_TYPE_LABEL_SUCCESS = 'GET_TOPIC_TYPE_LABEL_SUCCESS';
export const GET_TOPIC_TYPE_LABEL_FAIL = 'GET_TOPIC_TYPE_LABEL_FAIL';
